import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { useMemo } from 'react';
import { ModalOverlay, Modal } from 'react-aria-components';
import { ModalDialogContext } from './ModalDialogContext.es.js';

const modalOverlay = "_modal-overlay_i1kvn_17";
const fadeIn = "_fade-in_i1kvn_1";
const fadeOut = "_fade-out_i1kvn_1";
const modal = "_modal_i1kvn_17";
const styles = {
	modalOverlay: modalOverlay,
	fadeIn: fadeIn,
	fadeOut: fadeOut,
	modal: modal
};

const OverlayBase = (_a) => {
  var { children, className, isDismissable = true, isOpen, onOpenChange } = _a, props = __rest(_a, ["children", "className", "isDismissable", "isOpen", "onOpenChange"]);
  const contextValue = useMemo(() => ({ isDismissable }), [isDismissable]);
  return jsx(ModalDialogContext.Provider, { value: contextValue, children: jsx(ModalOverlay, Object.assign({ className: styles.modalOverlay, "data-zds": true, isDismissable, isOpen, isKeyboardDismissDisabled: !isDismissable, onOpenChange }, props, { children: jsx(Modal, { className: (renderProps) => {
    const dynamicClassName = typeof className === "function" ? className(renderProps) : className;
    return clsx(styles.modal, dynamicClassName);
  }, "data-zds": true, children }) })) });
};

export { OverlayBase };
//# sourceMappingURL=OverlayBase.es.js.map
